import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgKeyIconWhite = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_1244_8731)",
		children: [/* @__PURE__ */ _jsx("path", {
			d: "M8.7375 11.5125C8.41238 10.7149 8.24676 9.86131 8.25 9C8.25 7.66498 8.64588 6.35994 9.38758 5.2499C10.1293 4.13987 11.1835 3.27471 12.4169 2.76382C13.6503 2.25292 15.0075 2.11925 16.3169 2.3797C17.6262 2.64015 18.829 3.28303 19.773 4.22703C20.717 5.17104 21.3599 6.37377 21.6203 7.68315C21.8808 8.99252 21.7471 10.3497 21.2362 11.5831C20.7253 12.8165 19.8601 13.8707 18.7501 14.6124C17.6401 15.3541 16.335 15.75 15 15.75C14.1387 15.7532 13.2851 15.5876 12.4875 15.2625V15.2625L11.25 16.5H9V18.75H6.75V21H3V17.25L8.7375 11.5125Z",
			stroke: "#ffffff",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}), /* @__PURE__ */ _jsx("path", {
			d: "M16.875 8.25C17.4963 8.25 18 7.74632 18 7.125C18 6.50368 17.4963 6 16.875 6C16.2537 6 15.75 6.50368 15.75 7.125C15.75 7.74632 16.2537 8.25 16.875 8.25Z",
			fill: "#ffffff"
		})]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_1244_8731",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 24,
			height: 24,
			fill: "white"
		})
	}) })]
});
export default SvgKeyIconWhite;
